import React from 'react';

const RoundedImage = ({ src, alt, width, height }) => {
    return (
        <div style={styles.container}>
            <img
                src={src}
                alt={alt}
                style={{ ...styles.image, width: width || '100%', height: height || 'auto' }}
            />
        </div>
    );
};

const styles = {
    container: {
        overflow: 'hidden', // Ensure that the image stays within the container
        borderRadius: '8px', // Border radius for the entire image container
    },
    image: {
        borderRadius: '8px', // Rounded corners for the image itself
        objectFit: 'cover', // Make the image cover the container while maintaining aspect ratio
    }
};

export default RoundedImage;
